import React from 'react';

function QrImage(props) {
  return (
    <div className="my-qr-container">
      <div className="recharge-wallet-top-strip">
        <div
          onClick={() => {
            // this.setState({ selectedItem: null })
            props.setSelectedItem(null);
          }}
          style={{ paddingTop: 12 }}
        >
          <img className="qr-back" src="/images/back_arrow_bip.png" />
        </div>
        <div
          className="sub-section-account-general-title font13 center-text"
          style={{ paddingTop: 16 }}
        >
          <span className="bold-text">{props.t('PROFILE.MY_QR')}</span>
        </div>
        <div></div>
      </div>

      {props.data.getQrPending && !props.data.qrImage ? (
        <div></div>
      ) : props.data.qrImage ? (
        <div className="qr-image">
          <img src={props.data.qrImage.img_src} />
          <hr />
          <div className="qr-info flex-row space-between font10">
            {console.log('Login data ', props)}
            <span>
              {props.data.loginData.name}
              {' ' + props.data.loginData.last_name}
            </span>
            <span>{props.data.loginData.identity_val}</span>
          </div>
        </div>
      ) : props.data &&
        props.data.getQrError &&
        props.data.getQrError.data &&
        props.data.getQrError.data.error ? (
        <div className="trips-error-msg">
          <span>{props.data.getQrError.data.error}</span>
        </div>
      ) : null}
    </div>
  );
}

export default QrImage;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/QrImage.js